const getters = {
  getUrlApi: (state) => state.globals.urlApi,
	fullConfig: (state) => state.fullConfig,
	xs: function(state) {
		return window.matchMedia(`(max-width: ${parseInt(state.fullConfig.theme.screens.sm) - 1}px)`).matches
	},
	sm: function(state) {
		return window.matchMedia(`(min-width: ${state.fullConfig.theme.screens.sm})`).matches
	},
	md: function(state) {
		return window.matchMedia(`(min-width: ${state.fullConfig.theme.screens.md})`).matches
	},
	lg: function(state) {
		return window.matchMedia(`(min-width: ${state.fullConfig.theme.screens.lg})`).matches
	},
	getBrands: (state) => state.pages.home.brands,
  getTabs: (state) => state.pages.brand.tabs,
	getGridTwoCol: (state) => state.pages.home.gridTwoCol,
	getBgColourImg: (state) => state.pages.home.bgColourImg,
	getPlainImg: (state) => state.pages.home.plainImg,
  getProductProperties: (state) => {
    return state.pages.product.properties;
  },
  getProductAmazonUrl: (state, getters) => {
    // No ACF
    if(!Array.isArray(getters.getProductProperties.meta_data)) {
      return false;
    }

    return getters.getProductProperties.meta_data.find(acf => acf.key == 'amazon');
  },
  getProductNoonUrl: (state, getters) => {
    // No ACF
    if(!Array.isArray(getters.getProductProperties.meta_data)) {
      return false;
    }

    return getters.getProductProperties.meta_data.find(acf => acf.key == 'noon');
  },
  getActiveProductProperties: (state) => {
    return state.pages.product.active;
  },
  getActiveTabContent: (state) => state.pages.brand.tabContent,
};

export default getters;
